import { render, staticRenderFns } from "./WizardContentNumberInput.vue?vue&type=template&id=6b70003a&scoped=true&"
import script from "./WizardContentNumberInput.vue?vue&type=script&lang=ts&"
export * from "./WizardContentNumberInput.vue?vue&type=script&lang=ts&"
import style0 from "./WizardContentNumberInput.vue?vue&type=style&index=0&id=6b70003a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b70003a",
  null
  
)

export default component.exports